<div class="gb-staff-container">
  <gb-dashboard-sidenav [sidenavItems$]="staffSidenavItems$">
    <div sidenavHeader class="staff-sidenav-header"></div>
    <router-outlet></router-outlet>
  </gb-dashboard-sidenav>
</div>
